"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InactiveReferralCodeError = exports.SelfReferralCodeError = exports.AlreadyUsedReferralCodeError = exports.ExpiredReferralCodeError = exports.UnknownReferralCodeError = exports.InvalidReferralCodeError = exports.ReferralCodeError = exports.DisabledReferralServiceError = exports.IneligibleReferralServiceUserError = exports.ReferralServiceError = exports.ReferralErrorCode = exports.MaxDeleteAfterError = exports.MinDeleteAfterError = exports.NotEnoughPeanutsError = exports.MaxPeanutsError = exports.MinPeanutsError = exports.InvalidVpnConfigError = exports.NegativeBalanceError = exports.InvalidUserConfigError = exports.MyTmpVpnError = void 0;
const peanuts_1 = require("./models/peanuts");
class MyTmpVpnError extends Error {
    constructor(msg) {
        super(msg); // 'Error' breaks prototype chain here
        // See: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    }
}
exports.MyTmpVpnError = MyTmpVpnError;
class InvalidUserConfigError extends MyTmpVpnError {
    constructor(msg) {
        super(msg);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, InvalidUserConfigError.prototype);
    }
}
exports.InvalidUserConfigError = InvalidUserConfigError;
class NegativeBalanceError extends MyTmpVpnError {
    constructor(balance) {
        super(`Negative peanuts balance: ${(0, peanuts_1.peanutsToClient)(balance)}.`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, NotEnoughPeanutsError.prototype);
    }
}
exports.NegativeBalanceError = NegativeBalanceError;
class InvalidVpnConfigError extends MyTmpVpnError {
    constructor(msg) {
        super(msg);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, InvalidVpnConfigError.prototype);
    }
}
exports.InvalidVpnConfigError = InvalidVpnConfigError;
class MinPeanutsError extends InvalidVpnConfigError {
    constructor(min, given, balance) {
        super(`Minimum number of peanuts should be ${min}, you specified: ${(0, peanuts_1.peanutsToClient)(given)} and you have ${(0, peanuts_1.peanutsToClient)(balance)}.`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, MinPeanutsError.prototype);
    }
}
exports.MinPeanutsError = MinPeanutsError;
class MaxPeanutsError extends InvalidVpnConfigError {
    constructor(max, given, balance) {
        super(`Maximum number of peanuts should be ${max}, you specified: ${(0, peanuts_1.peanutsToClient)(given)} and you have ${(0, peanuts_1.peanutsToClient)(balance)}.`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, MaxPeanutsError.prototype);
    }
}
exports.MaxPeanutsError = MaxPeanutsError;
class NotEnoughPeanutsError extends InvalidVpnConfigError {
    constructor(given, balance) {
        super(`Not enough peanuts, you specified: ${(0, peanuts_1.peanutsToClient)(given)} and you have ${(0, peanuts_1.peanutsToClient)(balance)}.`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, NotEnoughPeanutsError.prototype);
    }
}
exports.NotEnoughPeanutsError = NotEnoughPeanutsError;
class MinDeleteAfterError extends InvalidVpnConfigError {
    constructor(min, given) {
        super(`deleteAfter must be greater than ${min}, you specified: ${given}.`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, MinDeleteAfterError.prototype);
    }
}
exports.MinDeleteAfterError = MinDeleteAfterError;
class MaxDeleteAfterError extends InvalidVpnConfigError {
    constructor(max, given) {
        super(`deleteAfter must be lesser than ${max}, you specified: ${given}.`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, MaxDeleteAfterError.prototype);
    }
}
exports.MaxDeleteAfterError = MaxDeleteAfterError;
var ReferralErrorCode;
(function (ReferralErrorCode) {
    ReferralErrorCode[ReferralErrorCode["UNKNOWN"] = 0] = "UNKNOWN";
    ReferralErrorCode[ReferralErrorCode["INVALID_CODE"] = 1] = "INVALID_CODE";
    ReferralErrorCode[ReferralErrorCode["CODE_EXPIRED"] = 2] = "CODE_EXPIRED";
    ReferralErrorCode[ReferralErrorCode["CODE_ALREADY_USED"] = 3] = "CODE_ALREADY_USED";
    ReferralErrorCode[ReferralErrorCode["SELF_REFERRAL"] = 4] = "SELF_REFERRAL";
    ReferralErrorCode[ReferralErrorCode["INACTIVE_CODE"] = 5] = "INACTIVE_CODE";
    ReferralErrorCode[ReferralErrorCode["USER_NOT_ELIGIBLE"] = 6] = "USER_NOT_ELIGIBLE";
    ReferralErrorCode[ReferralErrorCode["REWARD_DISTRIBUTION_FAILED"] = 7] = "REWARD_DISTRIBUTION_FAILED";
    ReferralErrorCode[ReferralErrorCode["SUSPICIOUS_ACTIVITY"] = 8] = "SUSPICIOUS_ACTIVITY";
})(ReferralErrorCode || (exports.ReferralErrorCode = ReferralErrorCode = {}));
class ReferralServiceError extends MyTmpVpnError {
    constructor(msg) {
        super(msg);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ReferralServiceError.prototype);
    }
}
exports.ReferralServiceError = ReferralServiceError;
class IneligibleReferralServiceUserError extends ReferralServiceError {
    constructor(referre) {
        super(`ineligible. See referral program conditions.`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, IneligibleReferralServiceUserError.prototype);
    }
}
exports.IneligibleReferralServiceUserError = IneligibleReferralServiceUserError;
class DisabledReferralServiceError extends ReferralServiceError {
    constructor() {
        super(`Referral service is currently disabled.`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, DisabledReferralServiceError.prototype);
    }
}
exports.DisabledReferralServiceError = DisabledReferralServiceError;
class ReferralCodeError extends ReferralServiceError {
    constructor(errorCode, referralCode, msg) {
        super(`Error with referral code: ${referralCode}: ${msg}`);
        this.errorCode = errorCode;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ReferralCodeError.prototype);
    }
}
exports.ReferralCodeError = ReferralCodeError;
class InvalidReferralCodeError extends ReferralCodeError {
    constructor(referralCode) {
        super(ReferralErrorCode.INVALID_CODE, referralCode, `Code must be of 8 hexadecimal digits, e.g.: ABCDEF12`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, InvalidReferralCodeError.prototype);
    }
}
exports.InvalidReferralCodeError = InvalidReferralCodeError;
class UnknownReferralCodeError extends ReferralCodeError {
    constructor(referralCode) {
        super(ReferralErrorCode.INVALID_CODE, referralCode, `Unknown code`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, UnknownReferralCodeError.prototype);
    }
}
exports.UnknownReferralCodeError = UnknownReferralCodeError;
class ExpiredReferralCodeError extends ReferralCodeError {
    constructor(referralCode) {
        super(ReferralErrorCode.INVALID_CODE, referralCode, `expired`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ExpiredReferralCodeError.prototype);
    }
}
exports.ExpiredReferralCodeError = ExpiredReferralCodeError;
class AlreadyUsedReferralCodeError extends ReferralCodeError {
    constructor(referralCode, alreadyUsedReferralCode) {
        super(ReferralErrorCode.CODE_ALREADY_USED, referralCode, `you have already used a referral code: ${alreadyUsedReferralCode}`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, AlreadyUsedReferralCodeError.prototype);
    }
}
exports.AlreadyUsedReferralCodeError = AlreadyUsedReferralCodeError;
class SelfReferralCodeError extends ReferralCodeError {
    constructor(referralCode) {
        super(ReferralErrorCode.SELF_REFERRAL, referralCode, `you cannot use you're own referral code`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, SelfReferralCodeError.prototype);
    }
}
exports.SelfReferralCodeError = SelfReferralCodeError;
class InactiveReferralCodeError extends ReferralCodeError {
    constructor(referralCode) {
        super(ReferralErrorCode.INACTIVE_CODE, referralCode, `inactive`);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, InactiveReferralCodeError.prototype);
    }
}
exports.InactiveReferralCodeError = InactiveReferralCodeError;
